import React, { useState, useContext } from "react"
import {
  InputGroup,
  InputGroupAddon,
  FormInput,
  Button,
  Form,
} from "shards-react"
import { GeneralContext } from "../context/general"

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

export default function KnowMoreInput() {
  const [email, setEmail] = useState(null)
  const {
    alert: { show },
  } = useContext(GeneralContext)

  const handleSubmit = e => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "know-more": "contact", email }),
    })
      .then(() =>
        show(
          "Su email ha sido registrado de manera exitosa, le contactaremos via correo."
        )
      )
      .catch(error => {
        alert("Error, intentelo más tarde")
        console.error(error)
      })

    e.preventDefault()
  }

  return (
    <Form
      name="know-more"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      onSubmit={handleSubmit}
      className="w-50 pb-5 mx-auto"
    >
      <InputGroup size="lg">
        <FormInput
          placeholder="Tu correo electrónico"
          name="email"
          onChange={e => setEmail(e.target.value)}
        />
        <InputGroupAddon type="append">
          <Button theme="success" type="submit" className="py-0">
            Saber más
          </Button>
        </InputGroupAddon>
      </InputGroup>
    </Form>
  )
}
